(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalFirmRegionDeleteController',AppraisalFirmRegionDeleteController);

    AppraisalFirmRegionDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppraisalFirmRegion'];

    function AppraisalFirmRegionDeleteController($uibModalInstance, entity, AppraisalFirmRegion) {
        var vm = this;

        vm.appraisalFirmRegion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppraisalFirmRegion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
